import { IGetWhiteList, PaginatedResult } from "../../interfaces";
import { IPair, IStorageTradingKey, IUserState } from "../../interfaces/user.interface";
import { actionTypes } from "../_actions/user.action";

const emptyPaginatedList = { 
  items: [], 
  meta: { 
    totalItems: 0, 
    itemCount: 0, 
    itemsPerPage: 0, 
    totalPages: 0, 
    currentPage: 1 
  }, 
  links: { 
    first: '', 
    last: '' 
  } 
} satisfies PaginatedResult<IGetWhiteList>;

const initialState: IUserState = {
  activeAddress: "",
  activeBalance: "",
  walletCurrency: null,
  mainAddress: "",
  mainChain: null,
  isKYCVerification: false,
  isAffiliate: null,
  isAffiliatePageEnabled: false,
  affiliateData: null,
  userKeys: [],
  userWhiteLists: emptyPaginatedList,
  userLockalKey: null as IStorageTradingKey,
  selectedPair: {} as IPair,
  minBalance: 0,
  userPoints: 0,
  userSocials: {
    twitter: null,
    discord: null,
    telegram: null,
    email: ""
  },
  userBalances: {}
};

const user = (state = initialState, action): IUserState => {
  switch (action.type) {
    case actionTypes.SAVE_WALLET_ADDRESS:
      return {
        ...state,
        activeAddress: action.data,
      };
    case actionTypes.SAVE_MAIN_WALLET:
      return {
        ...state,
        mainAddress: action.data.address,
        mainChain: action.data.chain
      };
    case actionTypes.SAVE_WALLET_BALANCE:
      return {
        ...state,
        activeBalance: action.data,
      };
    case actionTypes.SAVE_WHITE_LIST:
      return {
        ...state,
        userWhiteLists: action.data
      };
    case actionTypes.SAVE_TRADING_KEYS:
      return {
        ...state,
        userKeys: action.data,
      };
    case actionTypes.SAVE_KYC_STATUS:
      return {
        ...state,
        isKYCVerification: action.data,
      };
    case actionTypes.SAVE_AFFILIATE_STATUS:
      return {
        ...state,
        isAffiliate: action.data.isAffiliate,
        isAffiliatePageEnabled: action.data.isPageEnabled
      };
    case actionTypes.SAVE_AFFILIATE_DATA:
      return {
        ...state,
        affiliateData: action.data
      };
    case actionTypes.SAVE_USER_KEY:
      return {
        ...state,
        userLockalKey: action.data,
      };
    case actionTypes.SET_CURRENCY:
      return { 
        ...state,
        walletCurrency: action.data 
      };
    case actionTypes.SAVE_SELECTED_PAIR:
      return {
        ...state,
        selectedPair: { ...action.data }
      };
    case actionTypes.UPDATE_MIN_BALANCE: {
      return {
        ...state,
        minBalance: action.data
      }
    }
    case actionTypes.SAVE_USER_SOCIALS: {
      return {
        ...state,
        userPoints: action.data.userPoints,
        userSocials: action.data.userSocials
      }
    }
    case actionTypes.SAVE_USER_POINTS:
      return {
        ...state,
        userPoints: action.data
      }
    case actionTypes.UPDATE_USER_SOCIALS: {
      return {
        ...state,
        userSocials: action.data
      }
    }
    case actionTypes.UPDATE_USER_EVM_BALANCES: {
      return {
        ...state,
        userBalances: {...state.userBalances, ...action.data}
      }
    }
    default:
      return state;
  }
};

export default user;
